// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  imgConfig: [`t_pdp_thumb_d`, `t_pdp_thumb_d`, `t_pdp_thumb_d`],
};
